import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SimulationEditComponent } from './simulation-edit.component';
import { SimulationMainSettingsComponent } from './simulation-main-settings/simulation-main-settings.component';
import { SharedModule } from '@shared/shared.module';
import { CharacterEditComponent } from './character-edit/character-edit.component';
import { CharacterPromptComponent } from './character-prompt/character-prompt.component';
import { AssessmentEditComponent } from './assessment-edit/assessment-edit.component';
import { SimulationPreviewComponent } from './simulation-preview/simulation-preview.component';
import { AssessmentModule } from '@app/main/analytics/assessment/assessment.module';
import { ContextCardEditComponent } from './context-card-edit/context-card-edit.component';
import { ContextCardSectionComponent } from './context-card-edit/context-card-section/context-card-section.component';
import { SimulationIntroSettingsComponent } from './simulation-intro-settings/simulation-intro-settings.component';

@NgModule({
  declarations: [
    SimulationEditComponent,
    SimulationMainSettingsComponent,
    SimulationIntroSettingsComponent,
    CharacterEditComponent,
    CharacterPromptComponent,
    AssessmentEditComponent,
    SimulationPreviewComponent,
    ContextCardEditComponent,
    ContextCardSectionComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    AssessmentModule
  ]
})
export class SimulationEditModule { }
